(() => {
  document.documentElement.classList.add('bbb-filters-ready');
  const categoryTag = tag => /^000-bbb-(cat|nav|family)-/.test(tag) || /^000-bbb-root-(tilbehor|yttertoy|mellomlag|utstyr)$/.test(tag);
  const cleanURL = (clearCategory = false) => {
    const url = new URL(window.location.href);
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
    });
    if (clearCategory) {
      const parts = url.pathname.split('/');
      if (parts[1] === 'collections' && parts[3]) {
        const remaining = decodeURIComponent(parts[3]).split('+').filter(tag => !categoryTag(tag));
        url.pathname = parts.slice(0,3).join('/') + (remaining.length ? '/' + remaining.map(encodeURIComponent).join('+') : '');
      }
    }
    return url;
  };
  const sync = () => {
    const active = [...new URLSearchParams(location.search).keys()].some(key => key.startsWith('filter.')) || decodeURIComponent(location.pathname.split('/')[3] || '').split('+').some(categoryTag);
    document.querySelectorAll('[data-bbb-clear]').forEach(button => { button.hidden = !active; });
  };
  document.addEventListener('input', event => {
    const input = event.target;
    if (input.matches('[data-bbb-filter-search]')) {
      event.stopPropagation();
      const group = input.closest('[data-bbb-filter-group]');
      const query = input.value.trim().toLocaleLowerCase();
      let visible = 0;
      group.querySelectorAll('.tag-list .tag').forEach(row => {
        const label = (row.querySelector('.tag__text')?.textContent || row.querySelector('input')?.value || '').trim().toLocaleLowerCase();
        row.hidden = !query.split(/\s+/).every(part => {
          if (/^\d+$/.test(part)) return new RegExp('(^|[^0-9])' + part + '([^0-9]|$)').test(label);
          return label.includes(part);
        });
        if (!row.hidden && !row.classList.contains('hide')) visible++;
      });
      group.querySelector('[data-bbb-filter-empty]').hidden = visible > 0;
      group.querySelector('.collapsible-content.is-open')?.style.setProperty('height','auto');
      return;
    }
    if (input.matches('#FilterDrawer .filter-form input[type="checkbox"]')) {
      event.stopPropagation();
      input.closest('.tag')?.classList.toggle('tag--active',input.checked);
      document.dispatchEvent(new CustomEvent('bbb:filters-pending'));
    }
  }, true);
  document.addEventListener('bbb:filters-pending', () => {
    document.querySelectorAll('#FilterDrawer [data-bbb-clear]').forEach(button => { button.hidden = false; });
  });
  document.addEventListener('click', event => {
    const clear = event.target.closest('[data-bbb-clear]');
    if (clear) {
      event.preventDefault();
      window.location.assign(cleanURL(true).href);
      return;
    }
    const apply = event.target.closest('[data-bbb-apply]');
    if (!apply) return;
    const form = apply.closest('#FilterDrawer').querySelector('.filter-form');
    if (!form) return;
    const url = cleanURL();
    for (const [key,value] of new FormData(form)) {
      if (key.startsWith('filter.') && String(value).trim() !== '') url.searchParams.append(key,value);
    }
    apply.disabled = true;
    apply.setAttribute('aria-busy','true');
    window.location.assign(url.href);
  });
  document.addEventListener('collection:reloaded',sync);
  document.addEventListener('shopify:section:load',sync);
  sync();
})();


